export default "__VITE_ASSET__CBI0pqgE__"